import { useEffect,type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

/** The published pages are English until complete translated interfaces are available. */
export function LanguageProvider({ children }: { children: ReactNode }) {
  const { i18n } = useTranslation();
  useEffect(() => {
    if (i18n.language !== 'en') void i18n.changeLanguage('en');
  }, [i18n]);
  return <>{children}</>;
}
